var exports = {
  "SC": "CircleBadge__Z_4UW3",
  "a": "svgAvatar__tgzUAp",
  "tR": "flexCenter__Jh_8Ih",
  "w$": "verifiedIcon__nr58CH",
  "kZ": "downloadIcon__odI6-F",
};

module.exports = exports;
